module.exports = __webpack_public_path__ + "static/img/vip.6a18ad1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/account/vip.svg
// module id = EMjd
// module chunks = 0